import { createContext } from 'react'

type ActionsState = {
  triggerRebuild: () => Promise<void>
  signOut: () => Promise<void>
}

export const ActionsContext = createContext<ActionsState>({
  triggerRebuild: async () => {},
  signOut: async () => {},
})
